// Define the enum
export enum PartnerViewTabs {
  ProductTelemetry = "productTelemetry",
  Subscription = "subscription",
  PartnerProfile = "partnerProfile",
  TenantDetails = "tenantDetails",
  Engagements = "engagements"
}
